import { useConnection, useHubWaiting } from '../state/connection'
import { Loader } from './Loader'

export function ConnectionStatus() {
  const online = useConnection((s) => s.online)
  const waiting = useHubWaiting()
  if (!online) {
    return (
      <span className="status-pill offline" role="status">
        <span className="dot" aria-hidden="true" />
        Offline
      </span>
    )
  }
  if (waiting) {
    return (
      <span className="status-pill is-waiting" role="status">
        <Loader label="Connecting…" />
      </span>
    )
  }
  return null
}
